import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import { TVerificationRequest, TVerificationResponse } from '~/store/otp-verification/types.ts';

export const getVerificationStatusSubmit = createAsyncThunk<
  TVerificationResponse,
  TVerificationRequest
>('otp/personalDataApplicationsStatusSubmit', async ({ appId, token }, { rejectWithValue }) => {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const response = await api.get(
      `/personal-data/public/personal-data/applications/${appId}/auth-details`,
      {
        headers,
      }
    );
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const getVerificationStatusRevoke = createAsyncThunk<
  TVerificationResponse,
  TVerificationRequest
>('otp/personalDataApplicationsStatusRevoke', async ({ appId, token }, { rejectWithValue }) => {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const response = await api.get(
      `/personal-data/public/personal-data/revoke/applications/${appId}/auth-details`,
      {
        headers,
      }
    );
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});
